import { Button, Container, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import ImageCarousel from "../../components/Login/ImageCarousel";
import InputText from "../../components/InputText";
import { useFormik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  confirmSignUp,
  signIn,
  setUpTOTP,
  confirmSignIn,
} from "aws-amplify/auth";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";
import { setAuthenticatedUser } from "../../redux/slices/user";
import { toast } from "react-toastify";
import OtpInput from "../../components/OTPInput";
import { AUTHENTICATED } from "../../constants";

const VerifyOTP = () => {
  const [isLoading, setLoading] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleConfirmSignUp = async () => {
    try {
      setLoading(true);
      const response = await confirmSignIn({
        challengeResponse: otp?.join(""),
      });
      console.log(response, "confirmOTP");
      const { tokens: session } = await fetchAuthSession();
      const attributes = await fetchUserAttributes();
      const groups = session.accessToken.payload["cognito:groups"] || [];
      localStorage.setItem("loggedInUserGroups", JSON.stringify(groups));
      localStorage.setItem("token", JSON.stringify(session));
      localStorage.setItem("attributes", JSON.stringify(attributes));

      if (response.isSignedIn) {
        dispatch(
          setAuthenticatedUser({
            authState: AUTHENTICATED,
            role: groups[0],
            attributes,
          })
        );
        navigate("/");
      }
    } catch (error) {
      console.log(error.message);

      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          width: "100%",
          marginY: "auto",
          alignItems: "stretch",
          backgroundColor: "white",
          gap: 5,
        }}
      >
        <Stack
          sx={{
            backgroundColor: "#323232",
            borderRadius: "10px",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
            flexBasis: "50%",
            flexShrink: 0,
            padding: "20px 50px",
          }}
        >
          <Box>
            <img
              src="/assets/DreamStreamLogo.svg"
              alt=""
              width={"153px"}
              height={65}
            />
            <Typography sx={{ color: "secondary.main", textAlign: "center" }}>
              Magic in motion
            </Typography>
          </Box>
          <Box width={"100%"}>
            <ImageCarousel />
          </Box>
          <Typography textAlign={"center"} sx={{ color: "white" }}>
            Managing content made eaiser <br /> Create an account and start your
            journey today !
          </Typography>
        </Stack>

        <Stack
          sx={{
            gap: 4,
            flexBasis: "50%",
          }}
        >
          <Typography textAlign={"center"} variant="h4">
            Two Factor Authentication
          </Typography>
          <Typography>
            Thank you for choosing DreamStream. As part of our two-factor
            authentication process, use your authenticator application to view
            your verification code.
          </Typography>

          <Box>
            <OtpInput setOtp={setOtp} otp={otp} />
          </Box>
          <LoadingButton
            loading={isLoading}
            onClick={handleConfirmSignUp}
            variant="contained"
          >
            Submit
          </LoadingButton>
        </Stack>
      </Box>
    </Container>
  );
};

export default VerifyOTP;
